import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './RemoveAccommodation.css';

const RemoveAccommodation = () => {
  const [accommodations, setAccommodations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const fetchAccommodations = async () => {
    setLoading(true);
    setError(null);
    try {
      console.log("Fetching accommodations..."); // Debugging log
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/accomodations`);
      
      console.log("Fetched accommodations response:", response.data);
      
      setAccommodations(response.data.accommodations);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching accommodations:', error);
      setError('Failed to load accommodations. Please try again.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccommodations();
  }, []);

  const handleRemove = async (id) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5e71f6',
      cancelButtonColor: '#ef4444',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });

    if (result.isConfirmed) {
      setDeletingId(id);
      try {
        console.log(`Removing accommodation with ID: ${id}`);
        const response = await axios.delete(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/remove-accommodation/${id}`);
        
        console.log("Delete response:", response.data);

        setAccommodations(accommodations.filter(accommodation => accommodation._id !== id));
        setDeletingId(null);
        
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'Accommodation removed successfully!',
          confirmButtonColor: '#5e71f6',
        });
      } catch (error) {
        console.error('Error removing accommodation:', error);
        setDeletingId(null);
        
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: 'Failed to remove accommodation.',
          confirmButtonColor: '#5e71f6',
        });
      }
    }
  };

  if (loading) {
    return (
      <div className="paper-list-wrapper">
        <div className="accommodation-list-container">
          <div className="header-section">
            <h1 className="paper-list-title">Accommodation List</h1>
            <p className="paper-list-subtitle">Manage conference accommodation details</p>
          </div>
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading accommodations...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="paper-list-wrapper">
        <div className="accommodation-list-container">
          <div className="header-section">
            <h1 className="paper-list-title">Accommodation List</h1>
            <p className="paper-list-subtitle">Manage conference accommodation details</p>
          </div>
          <div className="error-container">
            <div className="error-icon">!</div>
            <p className="error-message">{error}</p>
            <button className="retry-button" onClick={fetchAccommodations}>
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="paper-list-wrapper">
      <div className="accommodation-list-container">
        <div className="header-section">
          <h1 className="paper-list-title">Accommodation List</h1>
          <p className="paper-list-subtitle">Manage conference accommodation details</p>
        </div>

        {accommodations.length === 0 ? (
          <div className="no-accommodations-box">
            <svg className="no-data-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="80" height="80">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <h3>No Accommodations Found</h3>
            <p>There are no accommodation details available at the moment. Add new accommodations to get started.</p>
          </div>
        ) : (
          <div className="accommodations-grid">
            {accommodations.map(accommodation => (
              <div key={accommodation._id} className="accommodation-card">
                <div className="accommodation-image-container">
                  <img 
                    src={accommodation.imageUrl} 
                    alt={accommodation.title} 
                    className="accommodation-image" 
                  />
                </div>
                <div className="accommodation-content">
                  <h3 className="accommodation-title">{accommodation.title}</h3>
                  <p className="accommodation-description">{accommodation.description}</p>
                </div>
                <div className="accommodation-actions">
                  <button 
                    className="remove-button" 
                    onClick={() => handleRemove(accommodation._id)}
                    disabled={deletingId === accommodation._id}
                  >
                    {deletingId === accommodation._id ? (
                      <>
                        <div className="button-spinner"></div>
                        Deleting...
                      </>
                    ) : (
                      <>
                        <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Remove
                      </>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RemoveAccommodation;
